import React from "react";
import { blackCloseIcon } from '../../assets/images'
import { errorWrap, errorText, errorButtonWrap, errorClose, successClose, successWrap, successText, successButtonWrap } from "./alert.module.css";

const Alert = ({ labelText, status, type, onClick, alertClose, failure, errorBoarder }) => {
  return (
      <> 
    {
      failure ? 
      <div className={errorWrap}>
        <div> 
          <span className={errorButtonWrap}> 
            <span>{status}</span> 
            <span>{type}</span>
          </span> 
          <p className={errorText}>{labelText}</p> 
        </div> 
        <img  
        onClick={onClick} 
        className={errorClose} src={blackCloseIcon} alt="icon" />
    </div>
    :

    <div className={successWrap}>
        <div> 
          <span className={successButtonWrap}> 
            <span>{status}</span> 
            <span>{type}</span>
          </span> 
          <p className={successText}>{labelText}</p> 
        </div> 
        <img  
        onClick={onClick} 
        className={successClose} src={blackCloseIcon} alt="icon" />
    </div>
  }
</>
  ); 
};

export { Alert }
  

